import type { ThemeConfig } from 'antd';
import { theme as antdTheme } from 'antd';
import type { CustomToken } from 'antd-style';

const baseToken = {
  colorPrimary: '#3373f6',
  borderRadius: 8,
  borderRadiusLG: 12,
  boxShadowTertiary:
    '0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 6px -1px rgba(16, 24, 40, 0.03)',
  // Internal admin tool, not a commercial product — free to lead with Apple's
  // system font stack (San Francisco on macOS/iOS/Safari) instead of shipping Inter.
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
} as const;

export const lightTheme: ThemeConfig = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    ...baseToken,
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      headerColor: '#030712',
      siderBg: '#ffffff',
      footerBg: '#ffffff',
    },
    Menu: {
      itemSelectedBg: '#eaf1fe',
      itemSelectedColor: baseToken.colorPrimary,
      itemActiveBg: '#f5f8ff',
      itemBorderRadius: 8,
      itemMarginInline: 8,
      itemHeight: 40,
    },
    Table: {
      headerBg: '#f5f8ff',
      headerColor: '#030712',
      rowHoverBg: '#f5f8ff',
    },
    Button: {
      fontWeight: 500,
      paddingBlock: 8,
      paddingBlockLG: 10,
    },
  },
};

export const darkTheme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    ...baseToken,
  },
};

/** @deprecated use lightTheme or darkTheme */
export const theme = lightTheme;

export const customToken: CustomToken = {};

export const useAntdToken = () => {
  const { useToken } = antdTheme;
  const { token } = useToken();
  return { token };
};
